<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <form [formGroup]="form">
    <div>
      <span><b>Montadora (OE)</b></span> 
      <div class="grid grid-cols-3 gap-3 mt-3">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Código</mat-label>
          <input matInput type="text" formControlName="code" />
        </mat-form-field>
      </div>
    </div>

    <div class="mt-3">
      <app-company-form
        #companyForm
        [states]="states"
        [parentFormGroup]="form"
      />
    </div>

    <div class="mt-3">
      <span><b>Outras Informações</b></span>      
      <div class="grid grid-cols-3 gap-3 mt-3">
        <app-select-form-field
          label="LB"
          [control]="productLine"
          [options]="productLines"
          [display]="codeDisplayName"
        />
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Percentual de Comissão</mat-label>
          <input matInput type="number" formControlName="commissionPercentage" />
        </mat-form-field>
      </div>
    </div>

    <div class="mt-3">
      <div class="flex flex-row mt-3 gap-4">
        <mat-checkbox formControlName="active">Ativo</mat-checkbox>
        <!-- <mat-checkbox formControlName="deleted">Excluido</mat-checkbox> -->
      </div>
      <div class="flex flex-row mt-3 gap-4">
        <mat-checkbox formControlName="orderCancellationMichelin">Permitir o cancelamento do pedido pela Michelin</mat-checkbox>
        <mat-checkbox formControlName="orderCancellationDistributor">Permitir o cancelamento do pedido pelo Distribuidor</mat-checkbox>
        <mat-checkbox formControlName="orderCancellationAutomaker">Permitir o cancelamento do pedido pela própria Montadora"</mat-checkbox>
      </div>
    </div>
  </form>
</mic-spinner-overlay>
